import zod from 'zod';

import { t } from '../../core/logical/type-presets.js';
import { propertyType } from '../../core/property/property-config.js';
import {
  FORMULA_PROPERTY_TYPE,
  FormulaPropertySchema,
  FormulaRawValueSchema,
} from './types.js';

export const formulaPropertyType = propertyType(FORMULA_PROPERTY_TYPE);

export const formulaPropertyModelConfig = formulaPropertyType.modelConfig({
  name: 'Formula',
  propertyData: {
    schema: FormulaPropertySchema,
    default: () =>
      ({
        _v: 1,
        expression: '',
        format: 'number',
        decimal: 2,
      }) as const,
  },
  // Number-typed so the column-stats footer offers Sum/Average/etc. The actual
  // per-row value is computed (see cell-renderer/compute), never stored — the
  // footer special-cases this type to evaluate live values.
  jsonValue: {
    schema: zod.number().nullable(),
    isEmpty: ({ value }) => value == null,
    type: () => t.number.instance(),
  },
  rawValue: {
    schema: FormulaRawValueSchema,
    default: () => null,
    toString: ({ value }) => value ?? '',
    fromString: ({ value }) => ({ value: value || null }),
    toJson: (): number | null => null,
    fromJson: () => null,
  },
});
